import Table, { compareNumbers, compareStrings } from 'apollo-react/components/Table';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';

const Cell = ({ row, column }) => <div>{row[column.accessor]}</div>;

const columns = [
  {
    header: 'Number',
    accessor: 'index',
    sortFunction: compareNumbers,
    customCell: Cell,
  },
  {
    header: 'Key',
    accessor: 'Key',
    sortFunction: compareStrings,
    customCell: Cell,
  },
  {
    header: 'Version',
    accessor: 'Version',
    sortFunction: compareStrings,
    customCell: Cell,
  },
];

const CustomTable = ({ title, rows }) => {
  const translateString = useTranslation();

  const getPaginationText = (isPlural) => {
    if (isPlural) {
      return title === 'Custom Forms' ? 'Forms' : 'Workflows';
    }
    return title === 'Custom Forms' ? 'Form' : 'Workflow';
  };

  return (
    <Table
      columns={columns}
      rowId="Key"
      emptyProps={{
        text: translateString('No data to display'),
      }}
      rows={rows.map((row) => ({
        ...row,
      }))}
      initialSortedColumn="index"
      initialSortOrder="asc"
      rowsPerPageOptions={[5, 10, 15, 'All']}
      rowProps={{ hover: false }}
      tablePaginationProps={{
        labelDisplayedRows: ({ from, to, count }) =>
          `${
            count === 1 ? getPaginationText(false) : getPaginationText(true)
          } ${from}-${to} of ${count}`,
      }}
    />
  );
};

export default CustomTable;
